<template>
  <div class="confetti-toggle__wrapper">
    <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
    <label class="confetti-toggle">
      <input
        class="confetti-toggle__input"
        type="checkbox"
        :checked="checked"
        :disabled="disabled"
        @change="$emit('change', $event.target.checked)"
      />
      <span
        :class="{
          'confetti-toggle__slider': true,
          'confetti-toggle__slider--disabled': disabled,
        }"
      >
        <span class="confetti-toggle__option confetti-toggle__option--left">
          {{ leftOption }}
        </span>
        <span class="confetti-toggle__option confetti-toggle__option--right">
          {{ rightOption }}
        </span>
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: "ConfettiToggle",
  model: {
    prop: "checked",
    event: "change",
  },
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    leftOption() {
      if (!this.options[0]) {
        return "";
      }

      return this.options[0].charAt(0);
    },
    rightOption() {
      if (!this.options[1]) {
        return "";
      }

      return this.options[1].charAt(0);
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:math";

@import "confetti/scss/variables/colors";

/* stylelint-disable max-nesting-depth */

$toggle-height: 2.4rem;
$toggle-width: 4.8rem;
$toggle-shadow: $color-grey-1000;
$toggle-text-unchecked: #acafb6;
$toggle-text-checked: $color-grey-100;
$toggle-bg-checked: $color-secondary-900;
$toggle-bg-unchecked: #e6e9ef;
$toggle-slider-unchecked: #acafb6;
$toggle-slider-checked: $color-grey-100;

.confetti-toggle {
  block-size: $toggle-height;
  display: inline-block;
  inline-size: $toggle-width;
  position: relative;

  &__input {
    block-size: 0;
    inline-size: 0;
    opacity: 0;
  }

  &__slider {
    background-color: $toggle-bg-unchecked;
    border-radius: 3.4rem;
    cursor: pointer;
    inset: 0;
    position: absolute;
    transition: 0.4s;

    &--disabled {
      opacity: 0.5;
    }

    &::before {
      background-color: $toggle-slider-unchecked;
      block-size: $toggle-height - 0.4rem;
      border-radius: 50%;
      box-shadow: 0 0.2rem 1rem 0 rgba($toggle-shadow, 18%),
        0 0 0.4rem 0 rgba($toggle-shadow, 12%);
      content: "";
      inline-size: math.div($toggle-width, 2) - 0.4rem;
      inset-block-end: 0.2rem;
      inset-inline-start: 0.2rem;
      position: absolute;
      transition: 0.4s;
      z-index: 1;

      input:checked + & {
        background-color: $toggle-slider-checked;
        transform: translateX($toggle-height);
      }
    }

    input:checked + & {
      background-color: $toggle-bg-checked;
    }
  }

  &__option {
    font-size: 1.2rem;
    font-weight: 600;
    inline-size: math.div($toggle-width, 2);
    line-height: 2.4rem;
    position: absolute;
    text-align: center;

    &--left {
      color: $toggle-text-checked;
      inset-inline-start: 0;
    }

    &--right {
      color: $toggle-text-unchecked;
      inset-inline-end: 0;
    }
  }
}
</style>
